import React, { useContext, useEffect, useState } from 'react'
import AppDataContext from '../../context/AppDataContext';
import useWindowSize from '../../hooks/useWindowSize';
import RiskUniverse from './components/RiskUniverse/RiskUniverse';
import classNames from "classnames";
import RevertIcon from "assets/images/svg/RevertIcon.svg";


export default function Library() {

  const { setHeaderShow, setHeaderData, setShowBackArrow }: any =
    useContext(AppDataContext);
  const {isUltraWide } = useWindowSize(); 
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  const datas = [
    {
      title: "Losing money due to factors such as market volatility or economic downturns.",
      location: "USA, NY",
      risk: 2
    },
    {
      title: "Business disruption due to risk such as equipment failure or system malfunctions",
      location: "USA, NY",
      risk: 0,
    },
    {
      title: "Negative publicity or damage to a company's reputation due to factors such as product recalls or ethical lapses",
      location: "USA, NY",
      risk: 1
    },
    {
      title: "Financial loss due to fraudulent activities such as embezzlement, identity theft, or accounting fraud",
      location: "USA, NY",
      risk: 2
    },
    {
      title: "Data breaches, hacking, or other cyberattacks that can compromise sensitive information",
      location: "USA, NY",
      risk: 2
    },
    {
      title: "Business disruption or loss due to technological failures, cyberattacks, or obsolete technology",
      location: "USA, NY",
      risk: 0
    },
    {
      title: "Delays, cost overruns, or failure to achieve project objectives",
      location: "USA, NY",
      risk: 2
    },
    {
      title:
        "Data breaches, hacking, or other cyberattacks that can compromise sensitive information",
      location: "USA, NY",
      risk: 1
    },
    {
      title: "Financial or legal penalties due to failure to comply with internal policies or external regulations",
      location: "USA, NY",
      risk: 2
    },
    {
      title: "Data breaches, hacking, or other cyberattacks that can compromise sensitive information",
      location: "USA, NY",
      risk: 1
    },
  ];

  const searchDropdownData = [
    {
      name: "Risks",
      value: 307,
    },
    {
      name: "Controls",
      value: 127,
    },
    {
      name: "Processes",
      value: 468,
    },
    {
      name: "Regulations",
      value: 96,
    },
    {
      name: "Vendors",
      value: 163,
    },
  ];

  const fromGroupClass = classNames({
    "d-flex position-relative ease-in-2ms": true,
    "border-bottom-gray-600 pb-3 mb-3": isDropdownOpen,
  });

  const timeLineClass = classNames({
    "time-line slide-in": true,
    "slide-down": isDropdownOpen,
  });

    useEffect(() => {
    setHeaderShow(!isUltraWide);
    setHeaderData({
      title: `Risk Library` 
    })
    }, [isUltraWide])
 
    
    const riskStatus = (risk: number)=> {
      let dotColor = 'bg-white';
      let riskLabel = "Medium decreasing";
      if (risk === 2) {
        dotColor = "bg-error-600";
        riskLabel = "High increasing";
      } else if (risk === 1){
        dotColor = "bg-indigo-600";
        riskLabel = "Medium increasing";
      }
      return (
        <>
          <span className={"dot mr-2 " + dotColor}></span> 
          riskLabel 
        </>
      );
    }


  return (
    <>
      {!isUltraWide && <RiskUniverse />}

      {/* For Ultra-wide */}

      {isUltraWide && (
        <>
          <div className="pa-3">
            <form className="search-form">
              <div className={fromGroupClass}>
                <h3
                  className="fw-300 cp d-inline-flex align-items-center"
                  onClick={() => setDropdownOpen(!isDropdownOpen)}
                >
                  Risks
                  <i className="icon-chevron-down ml-1"></i>
                </h3>
                <input title="Search" type="text" />
                <i className="icon-search placeholder-icon"></i>
              </div>

              <ul className={timeLineClass}>
                {searchDropdownData.map((data, i) => (
                  <li className="" key={i}>
                    <h6 className="text-gray-50 fw-400">{data.name}</h6>
                    <small>
                      <span className="dot bg-indigo-600 mr-1"></span>
                      {data.value}
                    </small>
                  </li>
                ))}
              </ul>
            </form>

            {/* Timeline */}

            <ul className="time-line">
              {datas.map((data, i) => (
                <li className="d-flex justify-content-between" key={i}>
                  <div className="d-inline-flex align-items-center">
                    <span
                      className="circle text-white bg-gray-800"
                      style={{
                        width: "2.5rem",
                        height: "2.5rem",
                        overflow: "visible",
                      }}
                    >
                      <img
                        src={RevertIcon}
                        style={{ width: "1.25rem" }}
                        alt="Strategy"
                      />
                    </span>

                    <div className="ml-3">
                      <h6 className="text-gray-50 fw-400">{data.title}</h6>
                      <span className="text-gray-400 fw-300">
                        <small className="text-uppercase text-7s">
                          {/* data.risk */}
                          {riskStatus(data.risk)}
                        </small>
                        <span className="text-gray-500">
                          <span className="mh-2">|</span>
                          <i className="icon-map-pin mr-2 text-2c"></i>
                          {data.location}
                        </span>
                      </span>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </>
      )}
    </>
  );
}
